__turbopack_context__.v({
  "last-updated": "last-updated-module-scss-module__ByfpyW__last-updated",
  "orange-highlight": "last-updated-module-scss-module__ByfpyW__orange-highlight",
  "orange-highlight-icon": "last-updated-module-scss-module__ByfpyW__orange-highlight-icon",
});
